import { BaseData } from 'types/base.type'
import { ErrorType } from 'types/error.type'
import { HearingSummaryType } from 'types/hearing-summary.type'
import client from './client'

class SummaryService {
  getById = async (hearingId?: string): Promise<BaseData<HearingSummaryType>> => {
    const url = `/oitiva/${hearingId}/resumo`

    return await client.get<BaseData<HearingSummaryType>>(url).then((res) => res)
  }

  save = async (hearingId?: string): Promise<BaseData<ErrorType>> => {
    const url = `/oitiva/${hearingId}/finalizar`

    return await client.post<BaseData<ErrorType>>(url).then((res) => res)
  }
}

export default new SummaryService()
